import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/store/auth";

const BASE_TITLE = "Telegram Multichat";

/**
 * Общее число непрочитанных во вкладке браузера.
 *
 * Оператор держит клиент фоновой вкладкой; без счётчика в заголовке о новом
 * сообщении узнаёшь, только вернувшись и обойдя аккаунты глазами.
 */
export function useUnreadTitle(): void {
  const token = useAuth((s) => s.token);

  const { data: unread = [] } = useQuery({
    queryKey: ["accounts", "unread"],
    queryFn: api.accountsUnread,
    enabled: !!token,
    // Точечно кэш обновляет useLiveCache; поллинг — страховка на случай
    // разрыва WS, когда события пролетают мимо.
    refetchInterval: 60_000,
  });

  useEffect(() => {
    const total = unread.reduce((acc, u) => acc + u.unread_messages, 0);
    document.title = total > 0 ? `(${total}) ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [unread]);
}
